"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

var _reactResizeDetector = require("react-resize-detector");

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _ChevronButton = _interopRequireDefault(require("../ChevronButton/ChevronButton"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _SliderContainerModule = _interopRequireDefault(require("./SliderContainer.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SliderContainer = function SliderContainer(_ref) {
  var children = _ref.children,
      title = _ref.title,
      description = _ref.description,
      cardWidth = _ref.cardWidth,
      cardHeight = _ref.cardHeight,
      isLoading = _ref.isLoading,
      contentToggle = _ref.contentToggle,
      removePadding = _ref.removePadding;
  var containerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      flipArrow = _useState2[0],
      setFlipArrow = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showArrow = _useState4[0],
      setShowArrow = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = _slicedToArray(_useState5, 2),
      showContent = _useState6[0],
      setShowContent = _useState6[1];

  var toggleShowContent = function toggleShowContent() {
    return setShowContent(!showContent);
  };

  var titleBuffer = title ? 35 : 0;
  var paddingBetweenCards = 16;

  var CardSliderLoader = /*#__PURE__*/_react.default.createElement(_reactContentLoader.default, {
    speed: 2,
    width: 1200,
    height: cardHeight ? cardHeight + titleBuffer : 209,
    viewBox: "0 0 1200 ".concat(cardHeight ? cardHeight + titleBuffer : 209),
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb"
  }, title ? /*#__PURE__*/_react.default.createElement("rect", {
    x: "12",
    y: "0",
    rx: "0",
    ry: "0",
    width: cardWidth / 2,
    height: "25"
  }) : null, [0, 1, 2, 3, 4, 5, 6].map(function (index) {
    return /*#__PURE__*/_react.default.createElement("rect", {
      key: "card-loader-card-".concat(index),
      x: index * (cardWidth + paddingBetweenCards) + 12,
      y: titleBuffer,
      rx: "3",
      ry: "3",
      width: cardWidth,
      height: cardHeight || 168
    });
  }));

  var scrollRight = function scrollRight() {
    var currentScrollPosition = containerRef.current.scrollLeft;
    containerRef.current.scroll({
      left: currentScrollPosition + cardWidth,
      behavior: 'smooth'
    });
  };

  var scrollToStart = function scrollToStart() {
    containerRef.current.scroll({
      left: 0,
      behavior: 'smooth'
    });
  };

  var handleScrollableContainer = function handleScrollableContainer() {
    var currentScrollPosition = containerRef.current.scrollLeft;
    var elemWidth = containerRef.current.scrollWidth;
    var offsetWidth = containerRef.current.offsetWidth;
    var percentageScrolled = currentScrollPosition / (elemWidth - offsetWidth);
    setFlipArrow(percentageScrolled > 0.9);
  };

  var handleScrollArrowClick = function handleScrollArrowClick() {
    if (flipArrow) {
      scrollToStart();
    } else {
      scrollRight();
    }
  };

  var potentiallyShowArrow = (0, _react.useCallback)(function () {
    var ref = containerRef.current;

    if (!isLoading && ref) {
      var shouldShowArrow = showContent && (ref === null || ref === void 0 ? void 0 : ref.scrollWidth) > (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) && children.length !== 1;
      setShowArrow(shouldShowArrow);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  var handleBrowserResize = (0, _react.useCallback)(function () {
    potentiallyShowArrow(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    potentiallyShowArrow(); // Only putting this here because we dont want to pass the ref into the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showContent, isLoading, children.length]);
  (0, _reactResizeDetector.useResizeDetector)({
    refreshMode: 'debounce',
    refreshRate: 600,
    onResize: handleBrowserResize,
    targetRef: containerRef
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: _SliderContainerModule.default.ContentLoader
  }, CardSliderLoader) : /*#__PURE__*/_react.default.createElement("div", {
    className: removePadding ? [_SliderContainerModule.default.ContainerBox, _SliderContainerModule.default.RemovePadding].join(' ') : _SliderContainerModule.default.ContainerBox
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SliderContainerModule.default.ContainerBox__header
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SliderContainerModule.default.Header__titleRow
  }, title ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: _FBUIConstants.TYPOGRAPHY_TYPES.HEADING_M,
    className: _SliderContainerModule.default.Header__textContainer
  }, title) : null, contentToggle ? /*#__PURE__*/_react.default.createElement(_ChevronButton.default, {
    onClick: toggleShowContent,
    className: _SliderContainerModule.default.HideButton,
    variant: _FBUIConstants.BUTTON_VARIANTS.SECONDARY,
    size: _FBUIConstants.BUTTON_SIZES.EXTRA_SMALL,
    flipChevron: showContent
  }, showContent ? 'Hide' : 'Show') : null), description ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: _FBUIConstants.TYPOGRAPHY_TYPES.BODY,
    className: _SliderContainerModule.default.Header__subheading
  }, description) : null), /*#__PURE__*/_react.default.createElement("div", {
    className: showContent ? _SliderContainerModule.default.MainSliderContainer : [_SliderContainerModule.default.MainSliderContainer, _SliderContainerModule.default.Hide].join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SliderContainerModule.default.SliderContainer,
    ref: containerRef,
    onScroll: function onScroll() {
      return handleScrollableContainer(containerRef);
    }
  }, showArrow ? /*#__PURE__*/_react.default.createElement("button", {
    className: _SliderContainerModule.default.ScrollArrowContainer,
    onClick: handleScrollArrowClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: flipArrow ? _SliderContainerModule.default.ReversibleArrow : [_SliderContainerModule.default.ReversibleArrow, _SliderContainerModule.default.reverse].join(' ')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _SliderContainerModule.default.TopBar
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _SliderContainerModule.default.BottomBar
  }))) : null, children))));
};

SliderContainer.propTypes = {
  children: _propTypes.default.node.isRequired,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]),
  description: _propTypes.default.string,
  cardWidth: _propTypes.default.number.isRequired,
  cardHeight: _propTypes.default.number,
  isLoading: _propTypes.default.bool,
  contentToggle: _propTypes.default.bool,
  removePadding: _propTypes.default.bool
};
var _default = SliderContainer;
exports.default = _default;

//# sourceMappingURL=SliderContainer.js.map